import React from "react";
// import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import EsenyurtIntro from "../components/ServiceRegions/İntros/EsenyurtIntro";
import DynamicImage from "../components/DynamicImage";


const EsenyurtPage = () => {
  return (
    <> 
    <div>
        
      {/* <HeroSlider /> */}
      <DynamicImage />
      {/* <AboutSection/> */}
      <EsenyurtIntro/>
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};
export default EsenyurtPage;